import NoVideo from '@mui/icons-material/Portrait';

interface NoRemoteVideoViewProps {
  remoteAttendeeId: string | null;
  hasRemoteParticipantLeft: boolean;
  attendeeName: string | undefined;
  participantType: string; // "provider" or "patient"
  isSpeaking?: boolean;
}

export const NoRemoteVideoView = ({
  remoteAttendeeId,
  hasRemoteParticipantLeft,
  attendeeName,
  participantType,
  isSpeaking = false
}: NoRemoteVideoViewProps) => {
  if (!remoteAttendeeId) {
    // No remote attendee yet
    return (
      <div className='flex flex-col items-center justify-center w-[30vw] h-[40vh] shadow-sm rounded-lg mx-auto border-2 border-white bg-gray-500'>
        <div className='flex flex-col items-center justify-center w-full h-full bg-black rounded-lg'>
          <div className='flex items-center justify-center w-full h-16 border-spacing-4 rounded-t-lg font-gentiumBasic text-white '>
            <NoVideo sx={{ fontSize: { sm: 100, md: 150, lg: 250 }, color: 'white' }} className='md:text-4xl text-slate-300' />
            <span className='font-normal text-pretty'>
              {`Waiting for the ${participantType === 'patient' ? attendeeName || 'provider' : attendeeName || 'patient'}...`}
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (hasRemoteParticipantLeft) {
    // Remote attendee has left
    return (
      <span className="text-2xl">
        {attendeeName
          ? `${attendeeName} has left the meeting.`
          : 'The other participant has left the meeting.'}
      </span>
    );
  }

  // Remote attendee is present but video is off
  return (
    <div className={`flex flex-col items-center justify-center w-[30vw] h-[40vh] shadow-sm rounded-lg mx-auto border-2 border-white ${isSpeaking ? 'bg-gray-500' : 'bg-blue-400'} bg-gray-500`}>
      <div className='flex flex-col items-center justify-center w-full h-full bg-black rounded-lg'>
        <div className='flex items-center justify-center w-full h-16 border-spacing-4 rounded-t-lg font-gentiumBasic text-white '>
          <div className='text-pretty font-normal'>
            {attendeeName
              ? `${attendeeName} is on audio only`
              : 'The other participant is on audio only'}
          </div>
        </div>
      </div>
    </div>
  );
}; 
